// frontend/packages/business-console/src/services/sitePageAuthoringService.js
//
// Thin client over the CMS copilot's service-page authoring endpoint
// (backend /api/v2/site-pages, plan 3.1.4). Pure generation: this returns the
// generated `services/{slug}.md` draft; the draft write to uat + publish reuse
// the existing content-editor service (writeContentDraft / publishContent),
// exactly like the AI blog writer. Business context rides the x-business-id
// header (axios interceptor in @upryzze/services); callers don't pass it.

import { api } from '@upryzze/services';

/**
 * Generate one structured service page from a short brief.
 * @param {object} args
 * @param {string} args.serviceName        e.g. "Drain Cleaning"
 * @param {string} args.serviceDescription one line about the service
 * @param {number} [args.order]            1-based position in the services index
 * @param {('call'|'form'|'book')} [args.primaryCta]
 * @returns {Promise<{ page: { slug, path, markdown, frontmatter }, tokensUsed, quotaWarning }>}
 */
export async function composeServicePage({
  serviceName,
  serviceDescription,
  order,
  primaryCta,
}) {
  // A full service page is a Sonnet copy pass (2048 output tokens) plus, when
  // the deterministic content gates fail, a second repair pass. That routinely
  // runs past the api client's 30s default, and an axios timeout has no status
  // so the response interceptor treats it as transient and REPLAYS the POST:
  // the operator waits 60s, gets a generic error, and the tenant is billed for
  // two generations the Console then throws away. Give the one slow call the
  // headroom it needs (same treatment workflowFormService gives its author).
  const { data } = await api.post(
    '/v2/site-pages/compose',
    {
      serviceName,
      serviceDescription,
      ...(order ? { order } : {}),
      ...(primaryCta ? { primaryCta } : {}),
    },
    { timeout: 240000 }
  );
  return data;
}
